import React from "react";
import Tabs from "../widgets/tabs";
import { InfoCard, InfoCardType, LabelType } from "../widgets/info_card";
import { Card } from "../widgets/card";
import Header from "../modules/pageHeader";
import ContactCardList from "../widgets/contact_card_list";
import Table from "../widgets/table";
import { headerType } from "../widgets/table";

const Home = () => {
  const tabData = [
    {
      label: "Overview",
      path: "Overview"
    },
    {
      label: "Properties",
      path: "Properties"
    },
    {
      label: "Invoicing",
      path: "Invoicing"
    },
    {
      label: "Scheduling",
      path: "Scheduling"
    },
    {
      label: "Quotes",
      path: "Quotes"
    },
  ];

  const headers: headerType[] = [
    {
      label: "Column 1",
      style: {
        alignment: { textAlign: "left" },
      },
    },
    {
      label: "Column 2",
      style: {
        alignment: { textAlign: "center" },
      },
    },
    {
      label: "Column 3",
      style: {
        alignment: { textAlign: "left" },
      },
    },
    {
      label: "Column 4",
      style: {
        alignment: { textAlign: "left" },
      },
    },
  ];
  const data = [
    ["Data 1", "Data 2", "Data 3", "Data 4"], // first row data
    ["Data 8", "Data 9", "Data 10"], //second row data
    ["Data 8", "Data 9", "Data 10"], //second row data
  ];
  const leftAlignColumns = [0];
  const centerAlignColumns = [1, 3];
  const rightAlignColumns = [2];

  return (
    <>
      <Header customer="Customer Name" />
      <main role="main">
        <div className="container-fluid">
          <div className="body-content">
            <Tabs tabs={tabData} />
            <div className="infoCardWrapper">
              <InfoCard
                cardTitle="House"
                cardType={InfoCardType.Account}
                details={[
                  {
                    labelType: LabelType.official,
                    label: "string",
                  },
                  {
                    labelType: LabelType.personal,
                    label: "string",
                  },
                  {
                    labelType: LabelType.email,
                    label: "string",
                  },
                ]}
              />
              <InfoCard
                cardTitle="Donna Hundson"
                cardType={InfoCardType.Billing}
                details={[
                  {
                    labelType: LabelType.official,
                    label: "string",
                  },
                  {
                    labelType: LabelType.personal,
                    label: "string",
                  },
                  {
                    labelType: LabelType.website,
                    label: "string",
                  },
                ]}
              />
              <InfoCard
                cardTitle="Scott Graby"
                cardType={InfoCardType.Ownership}
                details={[
                  {
                    labelType: LabelType.official,
                    label: "string",
                  },
                  {
                    labelType: LabelType.personal,
                    label: "string",
                  },
                  {
                    labelType: LabelType.email,
                    label: "string",
                  },
                ]}
              />
            </div>

            <div className="d-flex contentSection">
              <div className="col-md-6">
                <Card
                  cardTitle="Customer Contacts"
                  cardHeaderRightContent={
                    <div
                      className="newContact"
                      onClick={() => {
                        console.log("new contact");
                      }}
                    >
                      New Contact
                    </div>
                  }
                >
                  <ContactCardList
                    contacts={[
                      {
                        id: "contact1",
                        col1_1: "Justin Cotton",
                        col1_2: "jcotton@peachtreelandscape.com",
                        col2_1: "(615)203-6655",
                        col2_2: "(615)203-6655",
                        col2_3: 0,
                      },
                    ]}
                    onEdit={() => {
                      console.log("edit");
                    }}
                    onDelete={() => {
                      console.log("delete");
                    }}
                  />
                </Card>
              </div>
              <div className="col-md-6">
                <Card cardTitle="Installation Pricing">
                  <Table
                    id="installationPricingTable"
                    headers={headers}
                    data={data}
                  />
                </Card>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Home;
